import * as MXPixel from "../MXPixel/MedexpressPixel";
import { loadJSON } from "../Utils/Util";

declare let medexpress: any;

type AnalyticsInfo = {
  medicine: string;
  treatment: string;
  designType: string;
  showOnlyGeneric: string;
  compliantFlow: string;
};

export function registerAnalytics() {
  const info = getAnalyticsInfo();
  const analyticsDesignType = info.designType;

  const mxPixel = medexpress.MedexpressPixel as typeof MXPixel;

  mxPixel.addLoadPageEvent("View Product Page", {
    Medicine: info.medicine,
    Treatment: info.treatment,
  });

  mxPixel.addUserProperties({
    DesignType: analyticsDesignType,
    ShowingSubscriptions: true,
    ShowOnlyGeneric: info.showOnlyGeneric,
    CompliantFlow: info.compliantFlow,
  });

  mxPixel.addLoadPageEvent();
}

export function getAnalyticsInfo(): AnalyticsInfo {
  const info: any = loadJSON("analytics-info");

  if (!info.medicine || !info.treatment || !info.designType || !info.compliantFlow) {
    console.error("Invalid analytics info object " + info);
  }

  return info;
}
